export default __webpack_public_path__ + "static/media/featured-item-10.a5342ded.png";